import { theme } from '@fe-toolkit/web-components/ssr'

export type TTheme = typeof theme

export default theme
